import Common from "../Common";

const Color = class extends Common {
	browse = (): CustomResponse<Color[]> =>
		this.get(`/color`)
}

export default Color
